import idReader from './components/reader-id';
import insuranceReader from './components/reader-insurance';
import patientPanel from './components/patient-panel';
import patientDialog from './components/patient-dialog';
import patientSelector from './components/patient-selector';

const components = [idReader, insuranceReader, patientPanel, patientDialog, patientSelector];

const install = function (Vue) {
  if (install.installed) return;

  install.installed = true;

  components.forEach((com) => {
    Vue.component(com.name, com);
  });
};

export default {
  install,
  ...components,
};
